import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import pdfFile from "../../../../public/doc/Test.pdf";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

import {FormsModule} from '@angular/forms';
import {SafeResourceStringPipe} from '../../../pipes/safe-resource-string.pipe';
import {FeedbackDataService} from '../../../services/feedback-data.service';

@Component({
  selector: 'app-pdf-viewer',
  imports: [
    FormsModule,
    SafeResourceStringPipe
],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private feedbackService: FeedbackDataService) {
    this.feedbackService.feedbackData=null;
  }

  ngOnInit() {
  }

  getPdfFile():string{
    return "data:application/pdf;base64,"+btoa(String.fromCharCode(... pdfFile));
  }
}
